module.exports = __webpack_public_path__ + "static/img/11.385c33d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/11.png
// module id = sN3i
// module chunks = 2